export default __webpack_public_path__ + "static/media/business.6a80bbd7.svg";